import { render } from "./InterfaceCookies.vue?vue&type=template&id=30668501"
import script from "./InterfaceCookies.vue?vue&type=script&lang=js"
export * from "./InterfaceCookies.vue?vue&type=script&lang=js"

import "./InterfaceCookies.vue?vue&type=style&index=0&id=30668501&lang=scss"

import exportComponent from "/home/s-ol/dot/multi/multi-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__